import Message from '@/Messages/Message';
import ComponentManager from '@/Management/ComponentManager';
import WizardGroupFactory from '@/Factories/GroupFactories/WizardGroupFactory';

export default class WizardCreatedMessage extends Message {

    public wizard: WizardGroupFactory;

    public constructor(params: any) {
        super(params);

        this.wizard = this.paramOrDefault(params.wizard, null);
        this.undisposeProperties.push('wizard');
    }
}

ComponentManager.setMessage('WizardCreatedMessage', WizardCreatedMessage, 'RADPresentation.HTMLClient.DefaultViewExtensions');